import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import gql from 'graphql-tag';

const fetchUOMSQuery = gql`query {
  uom {
    id
    name
    code
  }
}`;

const uom = {
  namespaced: true,
  state: {
    uoms: [],
  },
  actions: {
    async fecthAll({ commit }) {
      try {
        const requestQuery = {
          query: fetchUOMSQuery,
        };

        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_UNIT_OF_MEASURES', result.data);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
  },
  mutations: {
    SET_UNIT_OF_MEASURES(state, data) {
      Vue.set(state, 'uoms', data.uom);
    },
  },
  getters: {
    uomsInfo: state => state.uoms,
  },
};

export default uom;



// WEBPACK FOOTER //
// ./src/store/modules/core/uom.js